export default __webpack_public_path__ + "static/media/HeroImage.4a6d5217.png";